import { useAuth0 } from '@auth0/auth0-react'; 

export default function LoginButton({ className = 'nav-link' }) {
  const { loginWithRedirect } = useAuth0();

  return (
    <button
      className="custom-button"
      onClick={() => loginWithRedirect()}>
      Login with SSO
    </button>
  );
}